import Api from "@/api/index";
import store from "@/store";
// import loading from "./loading";
import alerts from "@/components/alerts/alert";
import confirmations from "./confirmations";
import AuthenticationService from "@/services/AuthenticationService";
// import router from "@/router";

const profile = {
  namespaced: true,
  state: {
    all: [],
    datas: {},
    profile: null,
    lengkap: {
      birth_place: {
        name: "",
      },
      transportasi: {
        description: "",
      },
      pendidikan: {
        description: "",
      },
      program: {
        description: "",
      },
      province: {
        name: "",
      },
      regency: {
        name: "",
      },
      district: {
        name: "",
      },
      village: {
        name: "",
      },
      users: {
        avatar: "",
      },
    },
    queryParam: {},
    loading: false,
  },
  getters: {
    getDatas(state) {
      return state.datas;
    },
  },
  mutations: {
    SET_ALL(state, datas) {
      state.all = datas;
    },
    SET_DATAS(state, datas) {
      state.datas = datas;
    },
    SET_PROFILE(state, datas) {
      state.profile = datas;
    },
    SET_LENGKAP(state, datas) {
      state.lengkap = datas;
    },
    SET_LOADING(state, loading) {
      state.loading = loading;
    },
    SET_QUERY_PARAM(state, data) {
      state.queryParam = data;
    },
  },
  actions: {
    async getProfile({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("students/lengkapi-data/saya").then(({ data }) => {
        commit("SET_PROFILE", data);
        commit("SET_LOADING", false);
      });
    },

    async getLengkap({ commit }, payload) {
      commit("SET_LOADING", true);
      commit("SET_QUERY_PARAM", payload);
      return await Api.doGet("students/lengkapi-data/lengkap").then(
        ({ data }) => {
          commit("SET_LENGKAP", data);
          commit("SET_LOADING", false);
        }
      );
    },

    confirmation({ commit }, payload) {
      confirmations.confirmationForm(payload[0], `profile/${payload[1]}`);
    },
    async lengkapi({ commit, state }) {
      store.dispatch("loading/setLoading", true);
      return await AuthenticationService.postFormData(
        "students/lengkapi-data/saya",
        state.profile
      )
        .then(({ data }) => {
          alerts.sweetalertToast("success", data.message);
          store.dispatch("loading/setLoading", false);
          store.dispatch("profile/getProfile");
          store.dispatch("profile/getLengkap");
        })
        .catch((error) => {
          if (error.response.data.code === 400) {
            store.dispatch("errors/setError", error.response.data.errors);
          }
          store.dispatch("loading/setLoading", false);
          alerts.sweetalertToast("error", error.response.data.message);
        });
    },
  },
};

export default profile;
